import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function initSticky() {
    const banner = document.querySelector('.js-banner')
    // const footer = document.querySelector('footer')
    const content = document.querySelector('.js-content')
    const bannerContainer = document.querySelector('.js-banner-container')
    const bannerImage = document.querySelector('.js-banner-image')
    const blurBottom = document.querySelector('.blur-bottom')

    if (banner) {
        // create
        let mm = gsap.matchMedia()

        // add a media query. When it matches, the associated function will run
        mm.add('(min-width: 1024px)', () => {
            const tl = gsap.timeline({
                scrollTrigger: {
                    start: 'top top',
                    trigger: banner,
                    // pin: banner,
                    // markers: true,
                    scrub: true,
                    pinSpacing: true,
                    refreshPriority: 20
                }
            })
            tl.to(bannerImage, {
                y: -544,
                ease: 'none'
            })

            const st = ScrollTrigger.create({
                trigger: banner,
                start: 'bottom bottom',
                // markers: true,
                pin: true,
                pinSpacing: true,
                refreshPriority: 20
                // animation: tl,
                // scrub: true
            })

            return () => {
                // optional
                // custom cleanup code here (runs when it STOPS matching)
            }
        })
    }

    if (blurBottom) {
        gsap.set(blurBottom, { autoAlpha: 1 })
        gsap.to(blurBottom, {
            autoAlpha: 0,
            ease: 'none',
            scrollTrigger: {
                trigger: document.body,
                start: 'bottom-=300px bottom',
                end: 'bottom bottom',
                scrub: true
            }
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    initSticky()
})
